<!-- Plans and credit screen -->

<!-- Loading -->
<div *ngIf="loading">
  <div class="loading">
      <mat-spinner color="accent"></mat-spinner>
  </div>
</div>

<app-quick-guides #quickguides *ngIf="permissions?.can?.show_intro_tour?.site_settings && (uiManager.toggleQuickGuide$ | async)?.screen == 'plan' && (uiManager.toggleQuickGuide$ | async)?.show" [context]="this" guidesMode="plan"></app-quick-guides>

        <!-- Quick Guides icon-->
        <button mat-icon-button matTooltip="{{ 'NAV.QUICK_GUIDES' | translate }}" class="fdm-linked float-right" (click)="uiManager.toggleQuickGuidePopup('plan', true)">
          <fa-icon icon="question-circle"></fa-icon>
          </button>

<div class="row justify-content-center m-0">
  <div class="col-lg-10" style="margin-top:25px;">
  
  <!-- Plans and credit tab -->
  <mat-tab-group>
    <mat-tab label="{{ 'PLAN.P_N_C' | translate }}"><div style="margin-top:60px;"></div>
      <ng-container *ngIf="selectedPlan">

        <!-- Trial plan message -->
        <div class="alert alert-warning " *ngIf="fourD.activeTeam.plan.isTrial && fourD.activeTeam?.active">
          <fa-icon icon="exclamation-triangle"></fa-icon>    {{ 'PLAN.TRIAL' | translate: {daysLeft: isTrialDays } }}
        </div>

        <!-- Expiry plan messages -->
        <div class="alert alert-danger" *ngIf="!fourD.activeTeam?.active">
          <fa-icon icon="exclamation-triangle"></fa-icon>    {{ 'PLAN.EXPIRED_1' | translate }}
          <div class="mt-2 mb-2" translate>PLAN.EXPIRED_2</div>
          <span translate>PLAN.EXPIRED_3</span>: <a href="mailto:support@4dmapper.com">support@4dmapper.com</a>
        </div>
  
        <!-- Cancel subscription -->
        <h6 class="primary float-right">
          <button mat-raised-button
                *ngIf="!fourD.activeTeam.plan.isTrial && fourD.activeTeam?.active"
                (click)="cancelSubscription()" id="cancel-plan" color="warn">{{ 'PLAN.CANCEL_SUBSCRIPTION' | translate }}</button>
        </h6>
        
        <!-- Monthly plans-->
        <h4 translate class="mt-3 p-0">PLAN.PLANS</h4>

        <!-- Plans currency rates -->
        <p style="color:#555;max-width:40rem;">
          {{ 'PLAN.PLANS_CURRENCY' | translate }}
        </p>

        <!-- Plans description -->
        <p style="color:#555;max-width:40rem;">
          {{ 'PLAN.PLANS_DESCRIPTION' | translate }}
        </p>

        <!-- Subscribed -->
        <table class="mt-3" style="width:100%;margin-top:30px;">
          <tr class="equalHMWrap eqWrap">
            <td *ngFor="let cur of plans" class="fdm-plan equalHM eq maxx" [class.sel]="selectedPlan == cur">
              <div class="header" [title]="cur.id + ' - ' + cur.uid">
                <b>{{ cur.name | translateDb | async }}</b> &nbsp; <span *ngIf="fourD.activeTeam.plan == cur" class="badge badge-accent accent-bg" style="color:#fff" translate>PLAN.SUBSCRIBED</span>
              </div>
          </td>
          </tr>

          <tr class="equalHMWrap eqWrap">
            <td *ngFor="let cur of plans" class="fdm-plan equalHM eq maxx" [class.sel]="selectedPlan == cur">
              <div class="content">

                <div class="feature" *ngIf="cur.desc"> {{ cur.desc | translateDb | async }} </div>

                <div class="feature"> 
                  
                  <!-- Plan adjustments -->
                  <div *ngIf="selectedPlan == cur && ( curPlanAdjustments?.price != planAdjustments?.price || adjustments); else elseUsers">
                    <span class="badge badge-accent accent-bg" style="color:#fff">{{ cur.maxUsersBase + adjustedUsers }}</span> {{ 'ENTITY.USERS' | translate }} 

                    <span *ngIf="selectedPlan == cur" class="fdm-linked fdm-toggle-small ml-2" (click)="adjustUsers=!adjustUsers">
                      <span *ngIf="!adjustUsers" id="adjust-plan"><fa-icon icon="plus"></fa-icon> adjust</span>
                      <span *ngIf="adjustUsers"><fa-icon icon="minus"></fa-icon></span>
                    </span>

                    <!-- Adjust users -->
                    <div [slide-down]="adjustUsers">
                      <span style="font-size:10px">additional 0</span><mat-slider
                      thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['users']" [min]="0" [max]="50" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);">
                      </mat-slider><span style="font-size:10px">50</span>
                    </div>
      
                  </div>
                  <ng-template #elseUsers>
                    <span *ngIf="fourD.activeTeam.plan == cur">
                      {{ 'ENTITY.USING' | translate }}  
                      <span class="badge badge-accent accent-bg" style="color:#fff">{{ stats?.users }}</span> {{ 'ENTITY.OF' | translate }}   
                    </span>

                    <ng-container *ngIf="fourD.activeTeam.plan == cur && curPlanAdjustments">
                      {{ curPlanAdjustments.maxUsers }} {{ 'ENTITY.USERS' | translate }} 
                    </ng-container>
                    <ng-container *ngIf="fourD.activeTeam.plan != cur">
                      {{ cur.maxUsersBase }} {{ 'ENTITY.USERS' | translate }} 
                    </ng-container>
                  

                   
                  </ng-template>

                </div>

                <div class="feature"> 

                  <div *ngIf="selectedPlan == cur && ( curPlanAdjustments?.price != planAdjustments?.price || adjustments); else elseProjects">
                    <span class="badge badge-accent accent-bg" style="color:#fff">{{ cur.maxProjectsBase + adjustedProjects }}</span> {{ 'ENTITY.PROJ' | translate }} 

                    <!-- Adjust projects -->
                    <span *ngIf="selectedPlan == cur" class="fdm-linked fdm-toggle-small ml-2" (click)="adjustProjects=!adjustProjects">
                      <span *ngIf="!adjustProjects"><fa-icon icon="plus"></fa-icon> {{ 'ENTITY.ADJUST' | translate }}  </span>
                      <span *ngIf="adjustProjects"><fa-icon icon="minus"></fa-icon> </span>
                    </span>

                    <div [slide-down]="adjustProjects">
                      <span style="font-size:10px">{{ 'ENTITY.ADDITIONAL' | translate }}  0</span><mat-slider
                      thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['projects']" [min]="0" [max]="50" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);">
                      </mat-slider><span style="font-size:10px">50</span>
                    </div>

                  </div>
                  <ng-template #elseProjects>
                    <span *ngIf="fourD.activeTeam.plan == cur">
                      {{ 'ENTITY.USING' | translate }}  
                      <span class="badge badge-accent accent-bg" style="color:#fff">{{ stats?.projects }}</span> {{ 'ENTITY.OF' | translate }}  
                    </span>

                    <ng-container *ngIf="fourD.activeTeam.plan == cur && curPlanAdjustments">
                      {{ curPlanAdjustments.maxProjects }} {{ 'ENTITY.PROJ' | translate }}  
                    </ng-container>
                    <ng-container *ngIf="fourD.activeTeam.plan != cur">
                      {{ cur.maxProjectsBase }} {{ 'ENTITY.PROJ' | translate }}  
                    </ng-container>
                  
                  </ng-template>

                  <!-- <span *ngIf="selectedPlan == cur" class="fdm-linked" (click)="adjustProjects=!adjustProjects"><fa-icon icon="plus"></fa-icon></span>
                  <br>
                  <mat-slider *ngIf="selectedPlan == cur" [slide-down]="adjustProjects"
                    thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['projects']" [min]="0" [max]="100" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);"></mat-slider>
                  -->
                </div>

                <div class="feature"> 

                  <div *ngIf="selectedPlan == cur && ( curPlanAdjustments?.price != planAdjustments?.price || adjustments); else elseStorage">
                    <span class="badge badge-accent accent-bg" style="color:#fff">{{ ( ( adjustedStorage * 1000000000 ) + cur.maxStorageBase ) / 1000000000 | qmap_round }} GB  </span> {{ 'ENTITY.STORE' | translate }} 

                    <!-- Adjust storage -->
                    <span *ngIf="selectedPlan == cur" class="fdm-linked fdm-toggle-small ml-2" (click)="adjustStorage=!adjustStorage">
                      <span *ngIf="!adjustStorage"><fa-icon icon="plus"></fa-icon> {{ 'ENTITY.ADJUST' | translate }} </span>
                      <span *ngIf="adjustStorage"><fa-icon icon="minus"></fa-icon> </span>
                    </span>

                    <div [slide-down]="adjustStorage">
                      <span style="font-size:10px">{{ 'ENTITY.ADDITIONAL' | translate }} 0</span><mat-slider
                      thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['storage']" [min]="0" [max]="500" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);">
                      </mat-slider><span style="font-size:10px">500</span>
                    </div>

                  </div>
                  <ng-template #elseStorage>
                    <span *ngIf="fourD.activeTeam.plan == cur && curPlanAdjustments">
                      {{ 'ENTITY.USING' | translate }}  
                      <span class="badge badge-accent accent-bg" style="color:#fff">{{ 100*(stats?.quota / curPlanAdjustments.maxStorage) | qmap_round }}%</span> {{ 'ENTITY.OF' | translate }} 
                    </span>
                    <ng-container *ngIf="fourD.activeTeam.plan == cur && curPlanAdjustments">
                      {{ (curPlanAdjustments.maxStorage) / 1000000000 | qmap_round }} GB {{ 'ENTITY.STORE' | translate }}   
                    </ng-container>
                    <ng-container *ngIf="fourD.activeTeam.plan != cur">
                      {{ (cur.maxStorageBase) / 1000000000 | qmap_round }} GB {{ 'ENTITY.STORE' | translate }}   
                    </ng-container>
                  </ng-template>

                  <!-- <ng-container *ngIf="fourD.account.plan == cur">
                    {{ 'ENTITY.USING' | translate }}   
                    <span class="badge badge-accent accent-bg" style="color:#fff">{{ 100*(stats?.quota / fourD.account.plan.maxStorageBase) | qmap_round }}%</span> of 
                  </ng-container>
                  {{ (cur.maxStorageBase) / 1000000000 | qmap_round }} GB {{ 'ENTITY.STORE' | translate }}   -->
                  <!-- <span *ngIf="selectedPlan == cur" class="fdm-linked" (click)="adjustStorage=!adjustStorage"><fa-icon icon="plus"></fa-icon></span>
                  <br>
                  <mat-slider *ngIf="selectedPlan == cur" [slide-down]="adjustStorage"
                    thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['storage']" [min]="0" [max]="1000" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);"></mat-slider>
                  !-- <ng-container *ngIf="fourD.account.plan == cur">
                    <mat-progress-bar class="fdm-inline-progress" color="accent" mode="determinate" [value]="100*(stats?.quota / fourD.account.plan.maxStorageBase)"></mat-progress-bar>
                  </ng-container> -->
                </div>

                <div class="feature" *ngIf="cur['showCredits'] && !service.vasatInstance['disable_credits']"> 
                    <b> {{ 'PLAN.CURRENCY' | translate:{amount: cur.monthlyCredit} }}
                    </b> {{ 'PLAN.MONTHLY_CRED' | translate }}
                </div>
                  <!--
                  <div class="feature"> 
                    <ng-container *ngIf="fourD.account.plan == cur">{{ 'ENTITY.USING' | translate }}  <span class="badge badge-accent accent-bg" style="color:#fff">{{ stats?.teams }}</span> of </ng-container>
                    {{ cur.maxTeamsBase }} team{{ cur.maxTeamsBase > 1 ? 's' : '' }} 
                  </div>-->
                  
                <!-- <div class="feature" *ngIf="cur.desc?.length"> {{ cur.desc }}... </div> -->

                <div class="feature feature-rich" *ngIf="selectedPlan == cur && ( curPlanAdjustments?.price != planAdjustments?.price || adjustments); else elsePrice">
                  
                  <div> <span class="badge badge-primary primary-bg fdm-tag-large"  style="color:#fff">
                    {{ 'PLAN.CURRENCY' | translate:{amount: planAdjustments?.price} }}</span> <br> 
                    {{ subscriptionYearly ? 'PLAN.SUBSCRIPTION_YEARLY' : 'PLAN.SUBSCRIPTION_MONTHLY' | translate }}
                  </div>
                  <div style="margin-top:10px;color:#ccc;">
                    <b>{{ 'PLAN.CURRENCY' | translate: {amount: planAdjustments?.price - curPlanAdjustments?.price} }}</b> 
                    {{ 'PLAN.DIFFERENCE_MONTHLY' | translate }}</div>
                  
                </div>
                <ng-template #elsePrice>
                  <div class="feature feature-rich"> <span class="badge badge-primary primary-bg fdm-tag-large" style="color:#fff">
                    {{ 'PLAN.CURRENCY' | translate:{

                      amount: cur.cost ? subscriptionYearly ? (cur.cost * 10) : cur.cost  : ('PLAN.FREE' | translate)
                    }  
                  }}</span> <br>
                    {{ subscriptionYearly ? 'PLAN.SUBSCRIPTION_YEARLY' : 'PLAN.SUBSCRIPTION_MONTHLY' | translate }}
                  </div>  
                </ng-template>
                

                
              </div>
            </td>
          </tr>
          <tr class="equalHMWrap eqWrap">
            <td *ngFor="let cur of plans" class="fdm-plan equalHM eq maxx" [class.sel]="selectedPlan == cur">
              <div class="footer">
                <input type="checkbox" name="selector" [checked]="selectedPlan == cur" [disabled]="selectedPlan == cur" (click)="selectedPlan = cur; updateSliders();$event.stopPropagation();" /> 
                <div *ngIf="selectedPlan == cur" >{{ 'ENTITY.SELECTED' | translate }}</div>
                <div *ngIf="selectedPlan != cur">{{ 'PLAN.SELECT_PLAN' | translate }}</div>
              </div>
            </td>
          </tr>
          <tr class="equalHMWrap eqWrap">
            <td *ngFor="let cur of plans" class="fdm-plan equalHM eq maxx">
              <!-- <div class="fdm-plan sel" style="border:solid 2px red;" *ngIf="selectedPlan == cur && ( selectedPlan != fourD?.account?.plan || curPlanAdjustments?.price != planAdjustments?.price )">
                changed plan
              </div> -->
              <div style="text-align:center;margin-top:20px;"
                [class.maxx]="selectedPlan == cur && ( selectedPlan == fourD?.activeTeam?.plan && curPlanAdjustments?.price == planAdjustments?.price && !adjustments )" 
                *ngIf="selectedPlan == cur && ( selectedPlan == fourD?.activeTeam?.plan && curPlanAdjustments?.price == planAdjustments?.price && !adjustments )">
                <button mat-raised-button color="primary" (click)="adjustments = true">{{ 'PLAN.MODIFY' | translate }}</button>
              </div>

              <div style="text-align:center;margin-top:20px;" *ngIf="selectedPlan == cur && ( curPlanAdjustments?.price != planAdjustments?.price || adjustments)">

                <!-- Upgrade billing plan -->
                <div *ngIf="!billingSetup?.billingImpl?.length" style="margin-bottom:20px;">
                  <p>{{ 'PLAN.SWITCH_BILLING' | translate }}</p>
                  <button mat-raised-button color="primary" (click)="setDetails()">{{ 'PLAN.SWITCH_BILLING_BUTTON' | translate }}</button>
                </div>

                <button mat-raised-button style="font-size:17px !important;margin-right:15px;padding:8px 15px;margin-bottom:20px;" (click)="switchPlan(selectedPlan)"
                  *ngIf="billingSetup?.billingImpl?.length && ( selectedPlan != fourD?.activeTeam?.plan || curPlanAdjustments?.price != planAdjustments?.price )"
                  [disabled]="!billingSetup?.billingImpl?.length || stats?.quota / selectedPlan.maxStorage > 1 ||
                  stats?.users / selectedPlan.maxUsers > 1 ||
                  stats?.teams / selectedPlan.maxTeams > 1 ||
                  stats?.projects / selectedPlan.maxProjects > 1"
                  color="accent" id="switch-plan">{{ 'PLAN.SWITCH' | translate }}</button>
                  
                <button mat-raised-button (click)="reset()"><fa-icon icon="times"></fa-icon> {{ 'GENERIC.CANCEL' | translate }}</button>

              </div>

              <!-- <textarea *ngIf="cur" style="width:99%;height:222px;font-size:10px;">{{ cur | json }}</textarea> -->

            </td>
          </tr>
        </table>

        <!-- <div class="fdm-plan sel noshow" 
          [class.maxx]="selectedPlan != fourD?.account?.plan || curPlanAdjustments?.price != planAdjustments?.price || adjustments" style="margin:25px 0;" 
          [slide-down]="selectedPlan != fourD?.account?.plan || curPlanAdjustments?.price != planAdjustments?.price || adjustments">

          
          <div class="header">

            <h5>{{ 'PLAN.ADDITONAL_NEEDS' | translate }}</h5>

            <div class="equalHMWrap eqWrap">
              <div class="equalHM eq fdm-plan" style="color:#333;">
                <span class="badge badge-accent accent-bg" style="color:#fff">{{ planAdjustments?.allAdjustments['users'] ? planAdjustments?.allAdjustments['users'] : 0 }}</span> users
                <br><mat-slider thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['users']" [min]="0" [max]="50" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);"></mat-slider>
              </div>
              <div class="equalHM eq fdm-bucket" style="color:#333;">
                <span class="badge badge-accent accent-bg" style="color:#fff">{{ planAdjustments?.allAdjustments['storage'] ? planAdjustments?.allAdjustments['storage'] : 0 | qmap_round }} GB </span> storage
                <br><mat-slider thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['storage']" [min]="0" [max]="1000" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);"></mat-slider>
              </div>
              <div class="equalHM eq fdm-bucket" style="color:#333;">
                <span class="badge badge-accent accent-bg" style="color:#fff">{{ planAdjustments?.allAdjustments['projects'] ? planAdjustments?.allAdjustments['projects'] : 0 }}</span> projects
                <br><mat-slider thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['projects']" [min]="0" [max]="100" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);"></mat-slider>
              </div>
              <div class="equalHM eq fdm-bucket" style="color:#333;">
                <span class="badge badge-accent accent-bg" style="color:#fff">{{ planAdjustments?.allAdjustments['teams'] ? planAdjustments?.allAdjustments['teams'] : 0 }}</span> teams
                <br><mat-slider thumbLabel="true" [(ngModel)]="planAdjustments?.allAdjustments['teams']" [min]="0" [max]="10" (input)="showThumblabel($event);" (change)="updateSliders(true);hideThumblabel($event);"></mat-slider>
              </div>
            </div>
          </div>
          <div class="footer" style="padding-top:0;">
            <span *ngIf="curPlanAdjustments?.price != planAdjustments?.price">
              <div>A change of <b>${{ planAdjustments?.price - curPlanAdjustments?.price }}</b> per month</div>
              <div><b>New total <span class="badge badge-primary primary-bg fdm-tag-large">${{ planAdjustments?.price }}</span> per month</b></div>
            </span>

            <div style="vertical-align:top;padding-top:15px;">
              <button mat-raised-button style="font-size:17px !important;margin-right:15px;padding:8px 15px;" (click)="switchPlan(selectedPlan)"
              *ngIf="selectedPlan != fourD?.account?.plan || curPlanAdjustments?.price != planAdjustments?.price"
              [disabled]="!billingSetup?.billingImpl?.length || stats?.quota / selectedPlan.maxStorage > 1 ||
              stats?.users / selectedPlan.maxUsers > 1 ||
              stats?.teams / selectedPlan.maxTeams > 1 ||
              stats?.projects / selectedPlan.maxProjects > 1"
              color="accent">{{ 'PLAN.SWITCH' | translate }}</button>
              <button mat-raised-button (click)="reset()"><fa-icon icon="times"></fa-icon> Cancel</button>
            </div>
          </div>
        </div> -->

      </ng-container>


      <div style="margin:60px 0;" *ngIf="!service.vasatInstance['disable_credits']">
      
        <h4 class="mt-3 p-0">{{ 'PLAN.MY_BAL' | translate }}</h4> 
        <p style="color:#888;max-width:40rem;margin-bottom:25px;">
          {{ 'PLAN.CREDITS' | translate }}
        </p>

        <div class="equalHMWrap eqWrap" style="max-width:800px;margin-bottom:50px;">
          <div class="equalHM eq" style="color:#333;">

            <div class="fdm-plan maxx">

              <!-- Monthly allowance -->
              <div class="header" style="min-height:170px;" id="allowance-credits">
                <h6>{{ 'PLAN.MONTH_ALLOW' | translate }}</h6>
                <p>
                  <span class="badge badge-accent accent-bg fdm-tag-large" style="color:#fff">{{ (account?.autoCredit || 0) }} {{ 'ENTITY.CREDITS' | translate }}</span>
                  {{ 'ENTITY.LEFT' | translate }} <b>{{ account?.plan?.monthlyCredit || 0 }}</b> {{ 'ENTITY.TOTAL' | translate }}
                </p>
                <div style="text-align:center;margin-top:5px;">
                  {{ 'PLAN.TOPS_UP' | translate }} <span class="badge badge-accent accent-bg" style="color:#fff">{{ account?.planToDate | dateAgo | async }}</span>
                </div>
              </div>
              <div class="footer" style="padding:8px;"></div>
            </div>
          </div>

          <!-- Purchase additional credits -->
          <div class="equalHM eq" style="color:#333;">
            <div class="fdm-plan maxx">
              <div class="header" style="min-height:170px;">
                <h6>{{ 'PLAN.PURCH' | translate }}</h6>
                <p>
                  <span class="badge badge-accent accent-bg fdm-tag-large" style="color:#fff"> {{ (account?.adhocCredit || 0) | qmap_round}} {{ 'ENTITY.CREDITS' | translate }}</span>
                </p>
                <div style="text-align:center;margin-top:7px;" id="purchase-credits">
                  {{ 'PLAN.ADD_CREDIT' | translate }} <br>
                    <button mat-raised-button color="primary" style="margin-right:6px;" (click)="topup(30.0)">30</button> 
                    <button mat-raised-button color="primary" style="margin-right:6px;" (click)="topup(50.0)">50</button> 
                    <button mat-raised-button color="primary" style="margin-right:6px;" (click)="topup(100.0)">100</button>
                    <span mat-raised-button color="default" class="fdm-linked" style="margin-right:6px;" (click)="showOther=!showOther">{{ 'GENERIC.OTHER' | translate }} 
                      <fa-icon *ngIf="!showOther" icon="chevron-down"></fa-icon>
                      <fa-icon *ngIf="showOther" icon="chevron-up"></fa-icon>
                    </span>
                    <div [slide-down]="showOther">
                      <div style="margin:15px;padding:15px;border:dotted 1px #ccc;">
                        
                          <input #aname="ngModel" type="number" name="aname"min="1" max="1000" placeholder=" {{ 'MAP.CREDITS' | translate }}" [(ngModel)]="otherValue" style="border:solid 1px #aaa">
                        
                        <button mat-raised-button color="primary" style="margin-left:6px;" (click)="topup(otherValue)">{{ 'ENTITY.BUY' | translate }}</button>
                      </div>
                    </div>
                </div>
              </div>
              <div class="footer" style="padding:8px;"></div>
            </div>

          </div>

        </div>
     
        <!-- Used <span class="badge badge-accent accent-bg" style="color:#fff">{{ account?.autoCredit || 0 }} credits</span> of monthly {{ account?.plan?.monthlyCredit || 0 }} allowance
        

        <p>
          <span class="badge badge-accent accent-bg" style="color:#fff">{{ (account?.autoCredit || 0) + (account?.adhocCredit || 0) }} purchased credits</span>
        </p>
        <p>
          <button mat-raised-button color="primary" (click)="topup(30.0)">Top up $30</button> 
          <button mat-raised-button color="primary" (click)="topup(50.0)">Top up $50</button> 
          <button mat-raised-button color="primary" (click)="topup(100.0)">Top up $100</button>
        </p>
-->


          <!-- <h1>Credit:<span class="primary">{{ (account?.autoCredit || 0) + (account?.adhocCredit || 0) }}</span></h1>
          <small>Auto Topup: {{ account?.autoCredit || 0 }} Purchased: {{  account?.adhocCredit || 0 }} </small> -->
     
      </div>

    </mat-tab>

    <!-- Billing and invoices tab -->
    <mat-tab id="guide-billing-tab" label="{{'PLAN.B_N_I' | translate}}"> <div style="margin-top:20px;"></div>

      <!-- Billing contact table -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-4">
            <h4 translate class="mt-3  p-0">PLAN.BILLING_CONTACT</h4>
              <div class="billpane p-3">
                <ng-container *ngIf="billingSetup">
                  <label translate>PLAN.NAME</label>
                  <div class="pb-3">{{ billingSetup.name }}</div>
                  <label translate>PLAN.COMPANY</label>
                  <div class="pb-3">{{ billingSetup.company }}</div>
                  <label translate>PLAN.EMAIL</label>
                  <div class="pb-3">{{ billingSetup.email }}</div>
                  <label translate>PLAN.PHONE</label>
                  <div class="">{{ billingSetup.phone }}</div>
                  <label translate>PLAN.COUNTRY</label>
                  <div class="">{{ billingSetup.billerCountry }}</div>
                </ng-container>
                <div translate class="text-center p-3" *ngIf="!billingSetup">
                    {{ 'PLAN.NO_DETAILS' | translate }}
                </div>

                <!-- Edit button -->
                <div class="text-right">
                  <button mat-raised-button (click)="setDetails()" id="edit-contact" color="primary">{{ 'GENERIC.EDIT' | translate }}</button>
                </div>
              </div>
          </div>

          <!-- Past invoices -->
          <div class="col-8">
              <h4 translate class="mt-3 p-0" id="invoices-table">PLAN.BILLING_INVOICES</h4>
              
              <!-- No invoices message -->
                  <div class="text-center p-3" *ngIf="!invoices?.length">
                      {{ 'PLAN.INVOICE_NONE' | translate }}
                  </div>

                  <!-- Invoices table -->
                <table class="fdm-billing-table" *ngIf="invoices?.length">
                  <tr>
                      <th style="white-space:nowrap" translate>PLAN.INVOICE_NO</th>
                      <th translate>PLAN.INVOICE_DESC</th>
                      <th translate>PLAN.INVOICE_STATUS</th>
                      <th translate>PLAN.AMOUNT</th>
                      <th translate>PLAN.FROM_DATE</th>
                      <th translate>PLAN.TO_DATE</th>
                      <th> </th>
                  </tr>
                  <ng-container *ngFor="let cur of invoices">
                    <tr>
                      <td style="width:20px;">{{ cur.id }}</td>
                      <td style="width:50%;">
                        <div style="color:#333;margin-bottom:3px;" *ngIf="cur.name">{{ cur.name }}</div> 
                        <div *ngIf="cur.desc" style="color:#999;font-style: italic;">{{ cur.desc }}</div>
                      </td>
                      <td style="color:#aaa;font-style: italic;">{{ cur.invoiceStatus }}</td>
                      <td>${{ (cur.amount || cur.price) | qmap_round }}</td>
                      <td style="white-space:nowrap">{{ cur.fromDate | date}}</td>
                      <td style="white-space:nowrap">{{ cur.toDate | date}}</td>
                      <td>
                        <!-- PDF icons -->
                        <a *ngIf="cur.invNumber" [href]="cur.href" target="_new">
                          <button color="primary" mat-raised-button><fa-icon style="font-size:20px;" icon="file-pdf"></fa-icon></button>
                        </a>
                        <a *ngIf="!cur.invNumber && cur.href" [href]="cur.href" target="_new">
                          <button color="accent" mat-raised-button><fa-icon style="font-size:20px;" icon="file-pdf"></fa-icon></button>
                        </a>
                        <!-- <textarea *ngIf="cur.invNumber" style="width:100%;height:200px;font-size:9px;">{{ cur | json }}</textarea> -->
                      </td>
                    </tr>
                  </ng-container> 
                </table>
          </div>
        </div>
      </div>

    </mat-tab>

  </mat-tab-group>

    <!-- debug -->
     <!-- <table style="width:100%;margin-top:240px;">
      <tr>
        <td *ngIf="stats">stats <textarea style="width:99%;height:222px;font-size:10px;">{{ stats | json }}</textarea></td>
        <td *ngIf="account">account <textarea style="width:99%;height:222px;font-size:10px;">{{ account | json }}</textarea></td>
        <td *ngIf="selectedPlan">selectedPlan <textarea style="width:99%;height:222px;font-size:10px;">{{ selectedPlan | json }}</textarea></td>
        <td *ngIf="planAdjustments">planAdjustments <textarea style="width:99%;height:222px;font-size:10px;">{{ planAdjustments | json }}</textarea></td>
        <td *ngIf="curPlanAdjustments">curPlanAdjustments <textarea style="width:99%;height:222px;font-size:10px;">{{ curPlanAdjustments | json }}</textarea></td>
      </tr>
    </table> -->

      <!-- <div class="row p-0"> -->
        <!--
          <div class="col-4 pr-0 position-relative">
            <div *ngFor="let cur of plans" style="height: 80px;" class="w-100 p-3 billtab" [ngClass]="{'primary-dark-border-l':selectedPlan == cur,'billsel':selectedPlan == cur}" (click)="selectedPlan = cur; updateSliders()">
                <div class="float-right">
                  <b class="primary">
                  {{ cur.cost ?  '$ ' + (cur.cost) + ' per month'  : ('PLAN.FREE' | translate) }}</b> <br>
                  <span  *ngIf="fourD.account.plan == cur && planAdjustments && planAdjustments.price != cur.cost"> 
                    $ {{ planAdjustments.price }} with adjustments
                  </span>
                </div>
                <b>{{ cur.name | translate }}</b>
                {{ cur.desc | translate }}<span  *ngIf="fourD.account.plan == cur" class="badge badge-primary primary-bg">Current</span>
            </div>
          </div>
        -->

          <!-- <div class="col-8 p-4 bill-pane billbg">

              <div class="row">
                <div class="col-12 mb-3">
                    <h4 translate>PLAN.QUOTAS</h4>
                  </div>
              <div class="col-6 mh position-relative">
                <div class="row">
                  <div class="col-6">
                      <div> {{ 'GENERIC.STORAGE' | translate }}</div>
                      <div class="primary">{{ selectedPlan.maxStorageBase / 1000000000 | qmap_round }} GB</div>
                      <small>{{ 'PLAN.PREC_USED' | translate: {amount:100*(stats?.quota / selectedPlan.maxStorageBase) | qmap_round} }}</small>
                    <br> <small>{{ 'PLAN.TOTAL_STORAGE' | translate }}</small>
                  </div>
                  <div class="col-6">
                      <div>&nbsp;</div>
                      <mat-progress-spinner strokeWidth="3" class="fill" diameter="100" color="default" [value]="100"></mat-progress-spinner>
                      <mat-progress-spinner strokeWidth="3" class="fill" [color]="stats?.quota / selectedPlan.maxStorageBase > 0.9?'warn':''" [value]="100*(stats?.quota / selectedPlan.maxStorageBase)"></mat-progress-spinner>
                      <div class="text-center"><fa-icon icon="database" size="3x"></fa-icon></div>
                      <div>&nbsp;</div>
                      <mat-slider *ngIf="planAdjustments" [(ngModel)]="planAdjustments.allAdjustments['storage']" [min]="0" [max]="100" (change)="updateSliders(true)"></mat-slider>
                   
                  </div>
                </div>
              </div>

              <div class="col-6 mh position-relative">
                  <div class="row">
                    <div class="col-6">
                        <div>{{ 'PLAN.USERS' | translate }}</div>
                        <div class="primary">{{ selectedPlan.maxUsersBase }} </div>
                        <small>{{ 'PLAN.PREC_USED' | translate: {amount:100*(stats?.users / selectedPlan.maxUsersBase) | qmap_round} }}</small> <br>
                      <small>{{ 'PLAN.NUMBER_OF_USERS' | translate }}</small>
                    </div>
                    <div class="col-6">
                        <div>&nbsp;</div>
                        <mat-progress-spinner strokeWidth="3" class="fill" diameter="100" color="default" [value]="100"></mat-progress-spinner>
                        <mat-progress-spinner strokeWidth="3" class="fill"  [color]="stats?.users / selectedPlan.maxUsersBase > 0.9?'warn':''"  [value]="100*(stats?.users / selectedPlan.maxUsersBase)"></mat-progress-spinner>
                        <div class="text-center"><fa-icon icon="users" size="3x"></fa-icon></div>
                        <div>&nbsp;</div>
                        <mat-slider *ngIf="planAdjustments" [(ngModel)]="planAdjustments.allAdjustments['users']" [min]="0" [max]="10" (change)="updateSliders(true)"></mat-slider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-6 mh position-relative">
                    <div class="row">
                      <div class="col-6">
                          <div>      {{ 'NAV.MENU_PROJECTS' | translate }}</div>
                          <div class="primary">{{ selectedPlan.maxProjects }}</div>
                          <small>{{ 'PLAN.PREC_USED' | translate: {amount:100*(stats?.projects / selectedPlan.maxProjectsBase) | qmap_round} }}</small> <br>
                        <small>
                          {{ 'PLAN.PROJECTS_COLLECTION' | translate }}
                        </small>
                      </div>
                      <div class="col-6">
                          <div>&nbsp;</div>
                          <mat-progress-spinner strokeWidth="3" class="fill" diameter="100" color="default" [value]="100"></mat-progress-spinner>
                          <mat-progress-spinner strokeWidth="3" class="fill"  [color]="stats?.projects / selectedPlan.maxProjectsBase > 0.9?'warn':''" [value]="100*(stats?.projects / selectedPlan.maxProjectsBase)"></mat-progress-spinner>
                          <div class="text-center"><fa-icon icon="globe" size="3x"></fa-icon></div>
                          <div>&nbsp;</div>
                          <mat-slider *ngIf="planAdjustments" [(ngModel)]="planAdjustments.allAdjustments['projects']" [min]="0" [max]="10" (change)="updateSliders(true)"></mat-slider>

                      </div>
                    </div>
                  </div>

                  <div class="col-6 mh position-relative">
                      <div class="row">
                        <div class="col-6">
                            !--<div>{{ 'PLAN.PHOTOGRAM_TIME' | translate }}</div>
                            <div class="primary">{{ selectedPlan.photogramTime / 3600000 | qmap_round }} hours / month</div>
                            <small>{{ 'PLAN.PREC_USED' | translate: {amount:100*(stats?.procHours / selectedPlan.photogramTime) | qmap_round} }}</small>--
                          <div>{{ 'PLAN.MAX_TEAMS' | translate }}</div>
                          <div class="primary">{{ selectedPlan.maxTeams }}</div>
                        
                        </div>
                        <div class="col-6">
                          <div>&nbsp;</div>
                            <mat-progress-spinner strokeWidth="3" class="fill" diameter="100" color="default" [value]="100"></mat-progress-spinner>
                            <mat-progress-spinner strokeWidth="3" class="fill"  [color]="stats?.teams / selectedPlan.maxTeamsBase > 0.9?'warn':''" [value]="100*(stats?.teams / selectedPlan.maxTeamsBase)"></mat-progress-spinner>
                            <div class="text-center"><fa-icon icon="cubes" size="3x"></fa-icon></div>
                            <div>&nbsp;</div>
                            <mat-slider *ngIf="planAdjustments" [(ngModel)]="planAdjustments.allAdjustments['teams']" [min]="0" [max]="10" (change)="updateSliders(true)"></mat-slider>
                        </div>
                      </div>
                    </div>
            </div>
            !--
            <div class="row text-left mb-3 mt-3">
              <div class="col-12">
                <h4 translate>PLAN.FEATURES</h4>
              </div>
              <div class="col-12 p-2">
                  <fa-icon icon="check" ></fa-icon>
                  {{ 'MAP.PHOTOGRAM.TITLE' | translate }}
              </div>
              <div class="col-12 p-2">
                <fa-icon icon="check" ></fa-icon>
                {{ 'NAV.MENU_API' | translate }}
              </div>


            </div>
            --
            <div class="text-right">
                <button mat-raised-button (click)="switchPlan(selectedPlan)"
                 *ngIf="selectedPlan != fourD?.account?.plan || curPlanAdjustments?.price != planAdjustments?.price"
                 [disabled]="!billingSetup?.billingImpl?.length || stats?.quota / selectedPlan.maxStorage > 1 ||
                 stats?.users / selectedPlan.maxUsers > 1 ||
                 stats?.teams / selectedPlan.maxTeams > 1 ||
                 stats?.projects / selectedPlan.maxProjects > 1"
                 color="primary">{{ 'PLAN.SWITCH' | translate }}</button>

                 <span *ngIf="curPlanAdjustments?.price != planAdjustments?.price">A change of ${{ planAdjustments?.price - curPlanAdjustments?.price }}</span>
            </div>
        </div> -->

      <!-- </div> -->
   
    <!-- </div> -->

</div>
</div>